
export const TEXTS = {
  AUTH_TITLE: 'Work is no longer somewhere you go, it\'s something you do',
  PERSONAL_INFORMATION: 'Personal Information',
  DASHBOARD_TITLE: 'Easy first steps to a successful remote career',
  CLAIM_BENEFITS: 'Claim Benefits',
  GO_TO_REBENEFIT: 'Go to re:Benefit',
  ADD: 'Add',
  SAVE: 'Save',
  UPLOAD: 'Upload',
  RE_UPLOAD: 'Re-upload',
  OPEN_IN_NEW_TAB: 'Open in new tab',
  UPLOADED_RESUME: 'Uploaded Resume',
  UPLOADED_CERTIFICATE: 'Uploaded Certificate',
  ATTACH_FILE: 'Attach File',
  ATTACH_NEW_FILE: 'Attach New File',
  NOT_UPLOADED: 'Not uploaded yet',
  NOT_ADDED: 'Not added yet',
  COUNTRY: 'Country',
  TOWN: 'Town',
  STATUS: 'Status',
  PHONE: 'Phone',
  SUCCESS_UPLOADED: 'Successfully uploaded',
  SUCCESS_SAVED: 'Successfully saved',
  SUCCESS_REGISTERED: 'Successfully registered',
  SUCCESS_DELETED: 'Successfully deleted',
  NOT_ALLOWED_EXTENSION: 'Not allowed file extension',
  NOT_ALLOWED_SIZE: (allowedMB: string | number) => `Maximum allowed file size is ${allowedMB} MB`,
  PLEASE_TRY_AGAIN: 'Please Try Again',
  CERTIFICATES: 'Certificates',
  EDUCATION: 'Education',
  EXPERIENCE: 'Experience',
  SOMETHING_WENT_WRONG: 'Something went wrong!',
  PROCESS_OVERVIEW: [
    {
      title: '1. Become a member',
      description: 'The first step of your GigsRemote journey starts with signing up, telling us about yourself and updating your resume (CV).'
    },
    {
      title: '2. Strengthen your profile',
      description: 'To complete your profile, upload references, certificate and set your rate expectations, as well as the skills that make you valuable.'
    },
    {
      title: '3. Pre-selection & skills tests',
      description: 'Our career advisions and tech experts will assess your soft and tech skills in order to match you with the right companies.'
    },
    {
      title: '4. Matching with clients',
      description: 'After the screening, we\'ll set up interviews with clients and projects that fit your tech stack, experience, rate, preference, and availability.'
    },
    {
      title: '5. Your first project',
      description: 'We\'ll get you on onboard with all client operational specialist for your first project-timesheet management, status checks, invoice payments, etc.'
    },
  ],
  CV: 'CV',
  GENERAL_COMMUNICATION_ERROR: 'Failed to send your request, please try again later or contact us',
  PASSWORD_ERROR: 'password must be 8 characters or more and contain at least one letter, digit and special character',
  EXPIRED_PASSWORD_RESET_TOKEN: 'invalid or expired password reset request - please trigger a new one',
  MISSING_TOKEN: 'missing token - please try again or contact us',
  MISSING_TOKEN_ERR_MSG: 'must not be empty',
  OLD_PASSWORD: 'Old Password',
  PASSWORD: 'Password',
  NEW_PASSWORD: 'New Password',
  REPEAT_PASSWORD: 'Repeat Password',
  REPEAT_NEW_PASSWORD: 'Repeat New Password',
  SET_PASSWORD: 'Set Password',
  SET_PASSWORD_REBENEFIT: 'Set your re:Benefit password',
  CONFIRM: 'Confirm',
  RESET_PASSWORD: 'Reset Password',
  INVALID_EMAIL_OR_PASSWORD: 'Invalid e-mail or password',
  FORGOT_PASSWORD_QUESTION: 'Forgot password?',
  LOGIN: 'Login',
  SIGN_IN_TO_YOUR_ACCOUNT: 'Sign In to your account',
  EMAIL: 'E-mail',
  LINKS: 'Links',
  LINK: 'Link',
  FORGOT_ADMIN_PASSWORD: 'Forgot Admin Password',
  CREATE_ADMIN: 'Create Admin',
  RECOVER_YOUR_PASSWORD: 'Recover your password',
  SEND_RECOVERY_EMAIL: 'Send Recovery E-mail',
  MUST_BE_PROVIDED: 'Please populate this required field',
  RECOVER_EMAIL_SENT: 'Recovery e-mail has been sent',
  ACTIVATION_EMAIL_SENT: 'Activation e-mail has been sent',
  RECOVER_EMAIL_SENT_DETAILS: 'Follow the instructions from the e-mail to set new password - the link will be valid only for the next 30 minutes',
  YOUR_ACCOUNT_IS_VERIFIED_AND_ACTIVE: 'Your account is verified and active',
  UNDER_CONSTRUCTION: 'The freelancer portal is still under construction and will be available soon',
  LOGOUT: 'Logout',
  SOURCE: 'Source',
  NAME: 'Name',
  FIRST_NAME: 'First Name',
  LAST_NAME: 'Last Name',
  DESCRIPTION: 'Description',
  START_DATE: 'Start Date',
  END_DATE: 'End Date',
  COMPANY: 'Company',
  EDIT: 'Edit',
  ROLE: 'Role',
  AVAILABILITY: 'Availability',
  UPDATE: 'Update',
  SET: 'Set',
  NOT_SET: 'Not set',
  CANCEL: 'Cancel',
  TYPE: 'Type',
  WEEKLY_HOURS_AVAILABLE: 'Weekly Hours Available',
  PROJECT_PREFERENCE_TYPE: 'Project Preference Type',
  NEX_PROJECT_START: 'Next Project Start Date',
  EXPECTED_ABSENCES: 'Expected absences',
  FROM_HOUR: 'From Hour',
  TO_HOUR: 'To Hour',
  TIMEZONE: 'Timezone',
  RATE: 'Rate',
  AMOUNT: 'Amount',
  CURRENCY: 'Currency',
  RATE_TYPE: 'Rate Type',
  UNTIL_NOW: 'Until now',
  YES: 'Yes',
  NO: 'No',
  CONFIRMATION_DELETE: 'Are you sure you want to delete this entry?',
  LANGUAGES: 'Languages',
  LANGUAGE: 'Language',
  INVALID_TYPE: 'Invalid Type',
  PROFICIENCY: 'Proficiency',
  DELETE: 'Delete',
  PREVIEW: 'Preview',
  SUCCESS_PASSWORD_CHANGE: 'Password changed successfully',
  SETTINGS: 'Settings',
  CHANGE_PASSWORD: 'Change Password',
  ID: 'ID',
  CUSTOMER_ID: 'Customer ID',
  CLIENT_ID: 'Client ID',
  SEARCH: 'Search',
  NO_RECORDS_FOUND: 'No Records Found',
  REVISION_FILES: 'Revision Files',
  INCONSISTENT_CUSTOMER_TYPE: 'Inconsistent customer type',
  REGISTRATION_COMPLETED: 'Registration completed',
  COMPANY_NAME: 'Company Name',
  LEGAL_NAME: 'Legal Name',
  CONTACT_NAME: 'Contact Name',
  CREATE_NEW_CLIENT: 'New Client',
  CREATE_NEW_PROJECT_OPPORTUNITY: 'New Project Opportunity',
  COPIED_TO_CLIPBOARD: 'Copied to clipboard',
  TITLE: 'Title',
  OVERVIEW: 'Overview',
  POSITIONS: 'Positions',
  ADD_POSITION: 'Add Position',
  POSITION: 'Position',
  PROJECT_DETAILS: 'Project Details',
  CLIENT_INFO: 'Client Info',
  SKILLS: 'Skills',
  POSITION_AND_SKILLS: 'Position & Skills',
  UPDATE_POSITION: 'Update Position',
  SAVE_SKILLS: 'Save Skills',
  SAVE_POSITION: 'Save Position',
  APPLICANTS: 'Applicants',
  ADD_NEW_APPLICANT: 'Add New Applicant',
  ACCEPTED_BY_CLIENT: 'Accepted By Client',
  ACCEPTED_BY_FREELANCER: 'Accepted By Freelancer',
  INVALID_DATA: 'Invalid Data',
  FREELANCERS_LIST: 'Freelancers List',
  MESSAGE: 'Message',
  SUCCESS_ADDED: 'Successfully added',
  ADD_APPLICANT: 'Add Applicant',
  INSTITUTION: 'Institution',
  YEAR: 'Year',
  BULLHORN_CANDIDATE_PROFILE: 'Bullhorn Candidate Profile',
  BULLHORN_PROFILE: 'Bullhorn Profile',
  COPY: 'Copy'
} as const;